/**
 * CardSelectOverlayButton - transparent full-bleed button layered over a deck card
 * image to open the card details panel on click. Sits below interactive quantity
 * controls (which use pointer-events-auto) so it only captures clicks elsewhere.
 */
import type { ReactElement } from 'react';

import clsx from 'clsx';

export interface CardSelectOverlayButtonProps {
  cardName: string;
  onSelect: () => void;
  /** Match the parent image corner rounding. */
  rounded?: string;
}

export default function CardSelectOverlayButton({
  cardName,
  onSelect,
  rounded = 'rounded-lg',
}: CardSelectOverlayButtonProps): ReactElement {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={clsx(
        'absolute inset-0 cursor-pointer focus:outline-none',
        'focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-inset',
        rounded,
      )}
      aria-label={`View ${cardName} details`}
    />
  );
}
